module.exports = __webpack_public_path__ + "callout_illustration.6ae8dbac.svg";